import {Tab as PeacockTab} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').ITabProps} TabProps
 * @property {boolean} [disabled] When true, tab is rendered in disabled mode.
 * @property {string | import('react').ReactNode} [iconLeading] Leading icon/content.
 * @property {'arrow_drop_down' | 'close' | 'search' | 'arrow_drop_up' | 'warning' | import('react').ReactNode} [iconTrailing] Trailing icon/content.
 * @property {number} [index] Tab index.
 * @property {boolean} [isActive] Whether tab is currently active.
 * @property {string} label Tab label text.
 * @property {'horizontal' | 'vertical'} [orientation] Tab alignment direction.
 * @property {'shadow' | 'border' | 'line'} [type] Tab style variant.
 * @property {(indexClicked?: number) => void} [onClick] Callback when tab is clicked.
 * @property {import('@pepsico-ds/ui').ITagProps} [tag] Optional tag shown in tab.
 * @property {Array<{label: string, id: string, icon?: string | import('react').SVGProps<SVGSVGElement>, onClick: () => void}>} [subOptions] Optional dropdown options.
 * @property {boolean} [showSubOptions] Controls sub options dropdown visibility.
 * @property {(indexClicked?: number) => void} [onIconTrailingClick] Callback for trailing icon click.
 * @property {boolean} [skeleton] Renders skeleton state.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS Tab.
 * Supports all Peacock DS tab props.
 * Re-exports the Peacock Tab component reference for compatibility with TabsNavigation.
 * @type {import('react').FC<TabProps>}
 */
export const Tab = PeacockTab
